export default {
  playBookModules: [],
  playBookModule: undefined,
};
